import { render, staticRenderFns } from "./NuevoMovimiento.vue?vue&type=template&id=158ea410&scoped=true&"
import script from "./NuevoMovimiento.vue?vue&type=script&lang=js&"
export * from "./NuevoMovimiento.vue?vue&type=script&lang=js&"
import style0 from "./NuevoMovimiento.vue?vue&type=style&index=0&id=158ea410&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158ea410",
  null
  
)

export default component.exports